export default __webpack_public_path__ + "media/images/features/saga/illustrations_sp-8aa193546681c4fe9e8815fb0572daee.png";